import partial from "./partial.js";
import delay from "./delay.js";
import _ from "./underscore.js";
export default partial(delay, _, 1);
